import { ValueOf } from '@/types/util';

export const EGiftSetStatus = {
  SCHEDULED_SALE: '販売予定',
  SALE: '販売中',
  OUT_STOCK: '在庫切れ',
  SALE_END: '販売終了',
} as const;

export type GiftSetStatusKey = keyof typeof EGiftSetStatus;
export type GiftSetStatusValue = ValueOf<typeof EGiftSetStatus>;

export const giftSetStatusKeys = Object.keys(EGiftSetStatus) as GiftSetStatusKey[];

/** v-select用items */
export const giftSetStatusItems = giftSetStatusKeys
  .map((key) => ({
    title: EGiftSetStatus[key],
    value: key,
  }));
